var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"list-item margin-bottom-ml"},[_c('img',{staticClass:"bullet padding-left-m",attrs:{"src":_vm.image}}),_vm._v(" "),_c('div',[_c('div',{staticClass:"ri-bold-body"},[_vm._v(_vm._s(_vm.item.title))]),_vm._v(" "),_c('div',{staticClass:"ri-body"},[_vm._v(_vm._s(_vm.item.subTitle))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }